export default "__VITE_ASSET__DyKuLO0E__"